'use es6';

import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import I18n from 'I18n';
import { Component } from 'react';
import ConsentModal from 'conversations-visitor-experience-components/visitor-widget/ConsentModal';
import ConsentPrompt from 'conversations-visitor-experience-components/visitor-widget/ConsentPrompt';
import { trackInteraction as track } from '../../usage-tracking/actions/trackInteraction';
import { consentToCookies as consent } from '../../gdpr/actions/visitorConsentsToCookies';
import { declineCookies as decline } from '../../gdpr/actions/visitorDeclinesCookies';
import { getColoring } from '../../selectors/widgetDataSelectors/getColoring';
import { gdprCookieConsentOnExitIntentEnabled } from '../../utils/gdprCookieConsentPromptHelpers';
import { getLatestWidgetData } from '../../widget-data/selectors/getLatestWidgetData';
import { ChatWidgetLocaleContextConsumer } from 'conversations-visitor-experience-components/visitor-widget/ChatWidgetLocaleContext';
import { getAPIEnableWidgetCookieBanner } from '../../widget-ui/selectors/getAPIEnableWidgetCookieBanner';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
class CookieConsentPrompt extends Component {
  componentDidMount() {
    const {
      trackInteraction
    } = this.props;
    trackInteraction('widget-interaction', {
      action: 'view consent to cookies'
    });
  }
  render() {
    return /*#__PURE__*/_jsx(ChatWidgetLocaleContextConsumer, {
      children: locale => this.props.isExitIntentPrompt ? /*#__PURE__*/_jsx(ConsentModal, {
        headerMessage: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-visitor-ui.gdpr.consentToCookies.promptHeader",
          options: {
            locale
          }
        }),
        message: I18n.text('conversations-visitor-ui.gdpr.consentToCookies.exitIntentCookieConsent', {
          locale
        }),
        onDeclineClick: this.props.declineCookies,
        onClick: this.props.consentToCookies,
        coloring: this.props.coloring
      }) : /*#__PURE__*/_jsx(ConsentPrompt, {
        message: I18n.text('conversations-visitor-ui.gdpr.consentToCookies.pageLoadCookieConsent', {
          locale
        }),
        onDeclineClick: this.props.declineCookies,
        onClick: this.props.consentToCookies,
        coloring: this.props.coloring,
        showButton: true
      })
    });
  }
}
CookieConsentPrompt.displayName = 'CookieConsentPrompt';
CookieConsentPrompt.propTypes = {
  coloring: PropTypes.object,
  consentToCookies: PropTypes.func.isRequired,
  declineCookies: PropTypes.func.isRequired,
  isExitIntentPrompt: PropTypes.bool.isRequired,
  trackInteraction: PropTypes.func.isRequired
};
const mapDispatchToProps = {
  consentToCookies: consent,
  declineCookies: decline,
  trackInteraction: track
};
const mapStateToProps = state => {
  return {
    coloring: getColoring(state),
    widgetData: getLatestWidgetData(state),
    isExitIntentPrompt: gdprCookieConsentOnExitIntentEnabled(state) && !getAPIEnableWidgetCookieBanner(state)
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(CookieConsentPrompt);